<template>
  <el-dialog
    title="成品拆卸"
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
    top="5vh"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      size="small"
      label-width="100px"
      :rules="rules"
      :model="model"
      class="fix-width"
      inline
    >
      <el-form-item label="拆卸基地" prop="base_id">
        <BaseSelect v-model="model.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item label="拆卸日期" prop="operate_date">
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.operate_date"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="是否已使用" prop="is_used">
        <el-select v-model="model.is_used" placeholder="请选择">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="拆检情况">
        <el-input
          v-model="model.inspection"
          type="textarea"
          autosize
        ></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <FileUpload
          v-model="model.imgs"
          v-if="visible"
          style="min-width: 200px"
        ></FileUpload>
      </el-form-item>
      <el-form-item label="视频">
        <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <p class="bold">配件拆检情况</p>
    <el-table
      :data="model.item_records"
      border
      size="small"
      height="auto"
      style="max-height: 43vh"
    >
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="code" label="编号"></el-table-column>
      <el-table-column label="拆检情况">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.inspection"
            type="textarea"
            autosize
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <FileUpload v-model="scope.row.imgs" v-if="visible"></FileUpload>
        </template>
      </el-table-column>
      <el-table-column label="视频">
        <template slot-scope="scope">
          <VideoUploader
            v-model="scope.row.videos"
            v-if="visible"
          ></VideoUploader>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productDisassembleV2 } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        operate_date: [
          { required: true, message: '请选择拆卸日期', trigger: 'change' },
        ],
        base_id: [
          { required: true, message: '请选择拆卸基地', trigger: 'change' },
        ],
        is_used: [
          { required: true, message: '请选择是否已使用', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await productDisassembleV2(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
            this.visible = false
          }
          this.submiting = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>
